import _ from "lodash";
import Backbone from "backbone";
import BaseView from "scripts/views/baseView";
import DiagnosticsAuthenticationModel from "scripts/models/diagnosticsAuthenticationModel";
import inject from "scripts/ioc/inject";
import templateDiagnosticsScreen from "templates/diagnosticsScreen.hbs";
import templateDiagnosticsScreenGps from "templates/diagnosticsScreenGps.hbs";

const chan = Backbone.Radio.channel;

class DiagnosticsScreenView extends BaseView {
  constructor(options, geolocationService = inject("geolocationService")) {
    super(options);

    this.diagnosticsAuthenticationModel = new DiagnosticsAuthenticationModel();
    this.geolocationService = geolocationService;
  }

  get template() {
    return templateDiagnosticsScreen;
  }

  get events() {
    return {
      "click #bb-diagnositcs-screen-gps-button": "onClickGetGps",
      "click #bb-diagnostics-screen-back-button": "onClickBackButton",
      "click #bb-diagnostics-email": "onClickEmail",
      "click #bb-diagnostics-copy": "onClickCopy",
    };
  }

  render() {
    const organization = this.diagnosticsAuthenticationModel.get(
      "organization",
    );

    this.$el.html(
      this.template(
        _.merge(
          {
            date: this.diagnosticsAuthenticationModel.get("timestamp"),
            organizationName: organization
              ? organization.organizationName
              : void 0,
          },
          this.diagnosticsAuthenticationModel.toJSON(),
        ),
      ),
    );

    // initialize tooltip
    this.$el.find("#bb-diagnostics-copy").tooltip({
      placement: "top",
      trigger: "manual",
      container: "body",
    });

    return this;
  }

  renderGpsInfo(gpsInfo) {
    $("#gps-info-region").html(templateDiagnosticsScreenGps(gpsInfo));
  }

  sync() {
    return this.diagnosticsAuthenticationModel.fetch();
  }

  initialScrollTop() {
    return "bottom";
  }

  getDiagnosticsText() {
    return document
      .getElementById("bb-diagnostics-container")
      .innerText.replace(
        /Back|Email Diagnostics to (Support|support@biblioboard.com)|Copy Diagnostics/g,
        "",
      );
  }

  onClickGetGps() {
    chan("display").request("showBlockingLoader");

    this.geolocationService
      .getCurrentPosition()
      .then(location => {
        this.renderGpsInfo({
          gpsTime: parseInt(location.timeTaken, 10),
          gpsLatitude: location.position.coords.latitude,
          gpsLongitude: location.position.coords.longitude,
        });

        chan("display").request("hideBlockingLoader");
      })
      .catch(error => {
        console.error(error);

        chan("display").request("hideBlockingLoader");
      });
  }

  onClickBackButton() {
    chan("history").request("back");
  }

  onClickEmail(e) {
    e.target.href += `&body=${encodeURIComponent(this.getDiagnosticsText())}`;
  }

  onClickCopy() {
    navigator.clipboard
      .writeText(this.getDiagnosticsText())
      .then(() => {
        this.$el.find("#bb-diagnostics-copy").tooltip("show");
        setTimeout(() => {
          this.$el.find("#bb-diagnostics-copy").tooltip("hide");
        }, 3000);
      })
      .catch(() => console.log("Text cannot be copied"));
  }
}

export default DiagnosticsScreenView;
